import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { environment } from "src/environments/environment";
import { HttpService } from "../common/http-service";
import { SpecialOfferModel } from "../../models/business/special-offer.model";

const PRODUCT_API = environment.apiURL + '/api/adm/Product/';

@Injectable({
  providedIn: 'root'
})
export class SpecialOfferService {

  //#region Fields
  //#endregion

  //#region Constructor

  constructor(private _httpService: HttpService, private _httpClient: HttpClient) {
  }

  //#endregion

  //#region Public Methods
  getSpecialProduct() {
    let url = PRODUCT_API + "getspecialproduct";
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  getAllCountryNames() {
    let url = PRODUCT_API + 'getallcountrynames';
    return this._httpService.httpGet(url)
      .pipe(map(response => {
        return response;
      }));
  }

  addSpecialProduct(model: SpecialOfferModel) {
    let url = PRODUCT_API + "addspecialproduct";
    return this._httpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }

  updateSpecialProduct(model: SpecialOfferModel) {
    let url = PRODUCT_API + "updatespecialproduct";
    return this._httpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }

  deleteSpecialProduct(id: string) {
    let url = PRODUCT_API + "deletespecialproduct?Id=" + id;
    return this._httpService.httpPost(url, null)
      .pipe(map(response => {
        return response;
      }));
  }
  //#endregion
}
